export default "__VITE_ASSET__BsYwCmJ$__"